import { render } from "./SidebarTab.vue?vue&type=template&id=6df2626a"
import script from "./SidebarTab.vue?vue&type=script&lang=js"
export * from "./SidebarTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__